<script lang="ts">
  import { Link } from "@inertiajs/svelte";

  let { user = null }: {
    user?: { id: string; name: string; email: string; avatarUrl?: string } | null;
  } = $props();

  // Video modal state
  let showVideoModal = $state(false);
  const videoUrl = "https://www.youtube.com/embed/dQw4w9WgXcQ";

  // Email subscription
  let email = $state("");
  let subscribing = $state(false);
  let subscribed = $state(false);

  // Soulmate modal
  let showSoulmateModal = $state(false);
  const soulmateSchedule = [
    { day: "Day 1", places: ["하카타역", "캐널시티", "텐진 호르몬"] },
    { day: "Day 2", places: ["다자이후 텐만구", "유후인", "온천 료칸"] },
    { day: "Day 3", places: ["후쿠오카 타워", "모모치 해변", "야타이 포장마차"] },
  ];

  // Settlement demo modal
  let showSettlementModal = $state(false);

  async function handleSubscribe() {
    if (!email || !email.includes("@")) {
      alert("올바른 이메일 주소를 입력해주세요.");
      return;
    }
    subscribing = true;
    await new Promise(resolve => setTimeout(resolve, 1000));
    subscribed = true;
    subscribing = false;
    email = "";
  }

  function showFeatureAlert(feature: string) {
    alert(`${feature} 기능은 현재 준비 중입니다. 곧 만나보실 수 있습니다!`);
  }
</script>

<div class="min-h-screen" style="background: var(--bg);">
  <!-- Hero Section -->
  <section class="relative overflow-hidden" style="background: linear-gradient(135deg, var(--bg) 0%, rgba(32,178,170,0.06) 50%, rgba(16,185,129,0.04) 100%);">
    <div class="absolute inset-0 overflow-hidden pointer-events-none">
      <div class="absolute top-20 right-20 w-96 h-96 rounded-full blur-3xl" style="background: rgba(32,178,170,0.08);"></div>
      <div class="absolute bottom-20 left-20 w-96 h-96 rounded-full blur-3xl" style="background: rgba(16,185,129,0.06);"></div>
    </div>

    <!-- Navigation -->
    <nav class="relative z-50 backdrop-blur-xl border-b" style="background: var(--glass-bg); border-color: var(--border);">
      <div class="max-w-7xl mx-auto px-6 py-4">
        <div class="flex justify-between items-center">
          <div class="flex items-center gap-2">
            <img src="/icon.png" alt="TripHelper" class="w-10 h-10 rounded-xl" style="box-shadow: 0 4px 12px rgba(32,178,170,0.2);" />
            <span class="text-xl font-bold" style="color: var(--text-primary);">TripHelper</span>
          </div>
          <div class="flex items-center gap-4">
            {#if user}
              <Link href="/trips" class="font-medium transition-colors duration-200 cursor-pointer" style="color: var(--text-secondary);">
                내 여행
              </Link>
              <div class="w-8 h-8 rounded-full flex items-center justify-center text-white font-medium" style="background: linear-gradient(135deg, #20b2aa, #10b981);">
                {user.name.charAt(0)}
              </div>
            {:else}
              <Link href="/login" class="font-medium transition-colors duration-200 cursor-pointer" style="color: var(--text-secondary);">
                로그인
              </Link>
              <Link href="/signup" class="btn btn-primary px-6 py-2 rounded-xl cursor-pointer">
                시작하기
              </Link>
            {/if}
          </div>
        </div>
      </div>
    </nav>

    <div class="relative max-w-7xl mx-auto px-6 py-20 lg:py-32">
      <div class="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <!-- Left Content -->
        <div class="space-y-8 text-center lg:text-left">
          <div class="inline-flex items-center gap-2 px-4 py-2 rounded-full" style="background: var(--accent-dim);">
            <div class="w-2 h-2 rounded-full animate-pulse" style="background: var(--accent);"></div>
            <span class="text-sm font-medium" style="color: var(--accent);">iOS 앱 출시</span>
          </div>

          <div class="space-y-4">
            <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight" style="color: var(--text-primary);">
              여행을 더<br />
              <span style="background: linear-gradient(135deg, #20b2aa, #10b981); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;">스마트하게</span>
            </h1>
            <p class="text-xl max-w-xl" style="color: var(--text-secondary);">
              잠금화면에서 여행을 관리하세요.
            </p>
            <p class="text-lg max-w-xl" style="color: var(--text-muted);">
              실시간 예산 추적, 일정 알림, AI 추천까지 - 잠금 해제 없이.
            </p>
          </div>

          <!-- CTA Buttons -->
          <div class="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <Link href="/signup" class="btn btn-primary px-8 py-4 rounded-2xl cursor-pointer flex items-center justify-center gap-2 hover:scale-[1.02] transition-transform duration-200">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              <span class="font-medium">앱 다운로드</span>
            </Link>

            <button
              onclick={() => showVideoModal = true}
              class="btn btn-secondary px-8 py-4 rounded-2xl cursor-pointer flex items-center justify-center gap-2 transition-all duration-200"
            >
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M8 5v14l11-7z" />
              </svg>
              <span class="font-medium">영상 보기</span>
            </button>
          </div>

          <!-- Quick Stats -->
          <div class="flex items-center gap-8 pt-4 justify-center lg:justify-start">
            <div>
              <span class="text-3xl font-bold" style="color: var(--text-primary);">10K+</span>
              <p class="text-sm" style="color: var(--text-muted);">활성 사용자</p>
            </div>
            <div class="w-px h-12" style="background: var(--border-bright);"></div>
            <div>
              <div class="flex items-baseline gap-1">
                <span class="text-3xl font-bold" style="color: var(--text-primary);">4.9</span>
                <svg class="w-5 h-5 text-amber-500 fill-current" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                </svg>
              </div>
              <p class="text-sm" style="color: var(--text-muted);">앱 평점</p>
            </div>
            <div class="w-px h-12" style="background: var(--border-bright);"></div>
            <div>
              <span class="text-3xl font-bold" style="color: var(--text-primary);">50+</span>
              <p class="text-sm" style="color: var(--text-muted);">지원 국가</p>
            </div>
          </div>
        </div>

        <!-- Right Content - iPhone Mockup -->
        <div class="relative flex justify-center lg:justify-end">
          <div class="relative">
            <div class="relative w-72 sm:w-80 h-[600px] sm:h-[650px] bg-gradient-to-br from-gray-900 to-gray-800 rounded-[3rem] shadow-2xl p-3">
              <div class="absolute top-6 left-1/2 -translate-x-1/2 w-28 sm:w-32 h-7 sm:h-8 bg-black rounded-full z-10"></div>

              <div class="relative w-full h-full rounded-[2.5rem] overflow-hidden" style="background: linear-gradient(135deg, #20b2aa, #1a9e97, #10b981);">
                <div class="text-white text-center pt-14 sm:pt-16">
                  <div class="text-6xl sm:text-7xl font-light tracking-tight">14:32</div>
                  <div class="text-base sm:text-lg mt-1 opacity-90">일요일, 11월 30일</div>
                </div>

                <!-- Lock Screen Widget -->
                <div class="absolute bottom-28 sm:bottom-32 left-3 sm:left-4 right-3 sm:right-4">
                  <div class="bg-white/95 backdrop-blur-xl rounded-2xl sm:rounded-3xl p-4 sm:p-6 shadow-2xl border border-white/20">
                    <div class="flex items-start justify-between mb-3 sm:mb-4">
                      <div>
                        <div class="text-[10px] sm:text-xs text-muted mb-1">다음 목적지</div>
                        <div class="text-lg sm:text-xl font-semibold text-primary">텐진 호르몬</div>
                        <div class="flex items-center gap-1 text-xs sm:text-sm text-secondary mt-1">
                          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                          </svg>
                          0.8km &middot; 도보 5분
                        </div>
                      </div>
                      <div class="text-white px-2 sm:px-3 py-1 rounded-full text-[10px] sm:text-xs font-medium" style="background: var(--accent);">
                        Now
                      </div>
                    </div>

                    <div class="h-px bg-surface-hover my-3 sm:my-4"></div>

                    <div class="flex items-center justify-between">
                      <div>
                        <div class="text-[10px] sm:text-xs text-muted mb-1">남은 예산</div>
                        <div class="text-xl sm:text-2xl font-bold" style="color: #20b2aa;">&#8361;45,000</div>
                      </div>
                      <div class="text-right">
                        <div class="text-[10px] sm:text-xs text-muted mb-1">오늘 지출</div>
                        <div class="text-base sm:text-lg font-semibold text-secondary">&#8361;23,500</div>
                      </div>
                    </div>

                    <div class="mt-3 sm:mt-4 h-2 bg-surface-hover rounded-full overflow-hidden">
                      <div class="h-full w-[34%] rounded-full" style="background: linear-gradient(90deg, #20b2aa, #10b981);"></div>
                    </div>
                  </div>
                </div>

                <div class="absolute bottom-16 sm:bottom-20 left-1/2 -translate-x-1/2">
                  <div class="w-28 sm:w-32 h-1 bg-white/30 rounded-full"></div>
                </div>
              </div>
            </div>

            <!-- Floating notification -->
            <div class="absolute left-1/2 -translate-x-1/2 top-40 sm:top-48 w-44 sm:w-56 z-20">
              <div class="rounded-xl sm:rounded-2xl shadow-2xl p-3 sm:p-4 animate-bounce" style="background: var(--surface); border: 1px solid var(--border-bright);">
                <div class="flex items-start gap-2 sm:gap-3">
                  <div class="w-8 h-8 sm:w-10 sm:h-10 rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0" style="background: linear-gradient(135deg, #20b2aa, #10b981);">
                    <svg class="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                    </svg>
                  </div>
                  <div class="flex-1 min-w-0">
                    <div class="text-xs sm:text-sm font-medium" style="color: var(--text-primary);">스마트 추천</div>
                    <div class="text-[10px] sm:text-xs mt-1" style="color: var(--text-secondary);">대기시간 짧은 맛집 3곳</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Social Proof Section -->
  <section class="py-12 sm:py-16 border-y" style="background: var(--surface); border-color: var(--border);">
    <div class="max-w-7xl mx-auto px-6">
      <div class="flex flex-col md:flex-row items-center justify-center gap-6 sm:gap-8 md:gap-12">
        <!-- Avatar Stack -->
        <div class="flex items-center">
          <div class="flex -space-x-3">
            {#each ["#20b2aa", "#10b981", "#0d9488", "#059669", "#14b8a6"] as color, index}
              <div
                class="w-10 h-10 sm:w-12 sm:h-12 rounded-full border-4 flex items-center justify-center text-white shadow-lg"
                style="z-index: {5 - index}; border-color: var(--surface); background: {color};"
              >
                <svg class="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
            {/each}
          </div>
          <div class="ml-3 sm:ml-4 px-3 sm:px-4 py-1 rounded-full" style="background: var(--accent-dim);">
            <span class="text-xs sm:text-sm font-medium" style="color: var(--accent);">+10,000</span>
          </div>
        </div>

        <!-- Text & Rating -->
        <div class="text-center md:text-left">
          <div class="flex items-center gap-2 justify-center md:justify-start mb-2">
            <div class="flex text-amber-400">
              {#each [1,2,3,4,5] as _}
                <svg class="w-4 h-4 sm:w-5 sm:h-5 fill-current" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                </svg>
              {/each}
            </div>
            <span class="font-semibold" style="color: var(--text-primary);">4.9</span>
          </div>
          <p class="text-sm sm:text-base" style="color: var(--text-secondary);">
            <span class="font-semibold" style="color: var(--text-primary);">10,000+</span> 스마트 여행자가 신뢰합니다
          </p>
        </div>

        <!-- Badges -->
        <div class="hidden lg:flex items-center gap-4">
          <div class="px-4 sm:px-6 py-2 sm:py-3 rounded-xl" style="background: var(--surface-hover); border: 1px solid var(--border-bright);">
            <div class="text-[10px] sm:text-xs mb-1" style="color: var(--text-muted);">Featured on</div>
            <div class="text-xs sm:text-sm font-medium" style="color: var(--text-primary);">Product Hunt</div>
          </div>
          <div class="px-4 sm:px-6 py-2 sm:py-3 rounded-xl" style="background: var(--surface-hover); border: 1px solid var(--border-bright);">
            <div class="text-[10px] sm:text-xs mb-1" style="color: var(--text-muted);">Editor's Choice</div>
            <div class="text-xs sm:text-sm font-medium" style="color: var(--text-primary);">App Store</div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Features Section - Bento Grid -->
  <section class="py-16 sm:py-24" style="background: linear-gradient(180deg, var(--bg) 0%, var(--surface) 100%);">
    <div class="max-w-7xl mx-auto px-6">
      <!-- Section Header -->
      <div class="text-center mb-12 sm:mb-16">
        <div class="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-4" style="background: var(--accent-dim);">
          <svg class="w-4 h-4" style="color: var(--accent);" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
          <span class="text-sm font-medium" style="color: var(--accent);">강력한 기능</span>
        </div>
        <h2 class="text-3xl sm:text-4xl font-bold mb-4" style="color: var(--text-primary);">완벽한 여행을 위한 모든 것</h2>
        <p class="text-lg sm:text-xl max-w-2xl mx-auto" style="color: var(--text-secondary);">
          주머니 속 AI 여행 비서
        </p>
      </div>

      <!-- Bento Grid -->
      <div class="space-y-4 sm:space-y-6">
        <!-- Row 1 -->
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6">
          <!-- Feature A - Live Context (Large Card) -->
          <div class="lg:col-span-2 rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-12 text-white relative overflow-hidden group hover:shadow-2xl transition-all duration-300 min-h-[400px] sm:min-h-[500px]" style="background: linear-gradient(135deg, #20b2aa, #10b981);">
            <div class="absolute inset-0 opacity-10">
              <div class="absolute top-0 right-0 w-48 sm:w-64 h-48 sm:h-64 bg-white rounded-full -translate-y-1/2 translate-x-1/2"></div>
              <div class="absolute bottom-0 left-0 w-72 sm:w-96 h-72 sm:h-96 bg-white rounded-full translate-y-1/2 -translate-x-1/2"></div>
            </div>

            <div class="relative z-10 h-full flex flex-col">
              <div class="mb-4 sm:mb-6">
                <div class="w-12 h-12 sm:w-16 sm:h-16 bg-white/20 backdrop-blur-sm rounded-xl sm:rounded-2xl flex items-center justify-center mb-3 sm:mb-4">
                  <svg class="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                  </svg>
                </div>
                <h3 class="text-xl sm:text-2xl font-bold mb-2 sm:mb-3">나만의 여행 비서</h3>
                <p class="text-white/80 text-base sm:text-lg">
                  위치, 선호도, 상황에 맞는 실시간 맞춤 추천을 받아보세요.
                </p>
              </div>

              <div class="mt-auto">
                <div class="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 text-primary shadow-xl group-hover:scale-[1.02] transition-transform duration-300">
                  <div class="flex items-start gap-3 sm:gap-4">
                    <div class="w-10 h-10 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0" style="background: linear-gradient(135deg, #f97316, #ef4444);">
                      <svg class="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div class="flex-1 min-w-0">
                      <div class="flex items-center gap-2 mb-1 sm:mb-2">
                        <span class="text-xs sm:text-sm font-medium">스마트 추천</span>
                        <span class="text-[10px] sm:text-xs text-muted">방금</span>
                      </div>
                      <p class="text-xs sm:text-sm text-secondary mb-2 sm:mb-3">
                        대기가 길어요. 근처 대안 맛집 3곳을 찾았어요.
                      </p>
                      <div class="space-y-1 sm:space-y-2">
                        {#each [
                          { name: "마르게리타 피자", time: "도보 5분" },
                          { name: "스시 익스프레스", time: "도보 3분" },
                          { name: "타코 헤이븐", time: "도보 7분" }
                        ] as item}
                          <div class="flex items-center justify-between text-xs sm:text-sm">
                            <div class="flex items-center gap-2">
                              <svg class="w-4 h-4 text-muted" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                              </svg>
                              <span>{item.name}</span>
                            </div>
                            <span style="color: var(--accent);">{item.time}</span>
                          </div>
                        {/each}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Feature C - AI Matching -->
          <div class="rounded-2xl sm:rounded-3xl p-6 sm:p-8 text-white relative overflow-hidden group hover:shadow-2xl transition-all duration-300 min-h-[400px] sm:min-h-[500px]" style="background: linear-gradient(135deg, #0d9488, #0f766e);">
            <div class="absolute inset-0 opacity-10">
              <div class="absolute top-0 right-0 w-36 sm:w-48 h-36 sm:h-48 bg-white rounded-full -translate-y-1/2 translate-x-1/2"></div>
            </div>

            <div class="relative z-10 h-full flex flex-col">
              <div class="mb-4 sm:mb-6">
                <div class="w-12 h-12 sm:w-16 sm:h-16 bg-white/20 backdrop-blur-sm rounded-xl sm:rounded-2xl flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 transition-transform duration-300">
                  <svg class="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                </div>
                <h3 class="text-lg sm:text-xl font-bold mb-2 sm:mb-3">소울메이트 여행자</h3>
                <p class="text-white/70 text-sm sm:text-base mb-4 sm:mb-6">
                  비슷한 취향의 여행자 일정을 발견하세요.
                </p>
              </div>

              <div class="mt-auto bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 text-primary">
                <div class="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
                  <div class="w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center text-white" style="background: linear-gradient(135deg, #0d9488, #14b8a6);">
                    <svg class="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                  <div>
                    <div class="text-sm sm:text-base font-medium text-primary">맛집 탐험가</div>
                    <div class="text-xs sm:text-sm text-muted">후쿠오카 3일 여행</div>
                  </div>
                </div>

                <div class="flex items-center justify-center py-3 sm:py-4">
                  <div class="relative">
                    <svg class="w-24 h-24 sm:w-32 sm:h-32 transform -rotate-90">
                      <circle cx="48" cy="48" r="40" stroke="#E5E7EB" stroke-width="8" fill="none" class="sm:hidden" />
                      <circle cx="48" cy="48" r="40" stroke="url(#match-gradient-sm)" stroke-width="8" fill="none" stroke-dasharray="246" stroke-dashoffset="5" stroke-linecap="round" class="sm:hidden" />
                      <circle cx="64" cy="64" r="56" stroke="#E5E7EB" stroke-width="8" fill="none" class="hidden sm:block" />
                      <circle cx="64" cy="64" r="56" stroke="url(#match-gradient)" stroke-width="8" fill="none" stroke-dasharray="345" stroke-dashoffset="7" stroke-linecap="round" class="hidden sm:block" />
                      <defs>
                        <linearGradient id="match-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" stop-color="#20b2aa" />
                          <stop offset="100%" stop-color="#10b981" />
                        </linearGradient>
                        <linearGradient id="match-gradient-sm" x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" stop-color="#20b2aa" />
                          <stop offset="100%" stop-color="#10b981" />
                        </linearGradient>
                      </defs>
                    </svg>
                    <div class="absolute inset-0 flex items-center justify-center">
                      <div class="text-center">
                        <div class="text-2xl sm:text-3xl font-bold" style="color: #20b2aa;">98%</div>
                        <div class="text-[10px] sm:text-xs text-muted">일치</div>
                      </div>
                    </div>
                  </div>
                </div>

                <button
                  onclick={() => showSoulmateModal = true}
                  class="w-full py-2 text-white rounded-lg sm:rounded-xl text-xs sm:text-sm font-medium hover:shadow-lg transition-shadow duration-200 cursor-pointer"
                  style="background: linear-gradient(135deg, #20b2aa, #10b981);"
                >
                  일정 보기
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 2 -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          <!-- Feature B - 1-Click Settlement -->
          <div class="card card-hover border-2 rounded-2xl sm:rounded-3xl p-6 sm:p-8 relative overflow-hidden group" style="border-color: var(--border);">
            <div class="absolute top-0 right-0 w-24 sm:w-32 h-24 sm:h-32 rounded-full -translate-y-1/2 translate-x-1/2 opacity-30" style="background: linear-gradient(135deg, rgba(32,178,170,0.2), rgba(16,185,129,0.2));"></div>

            <div class="relative z-10">
              <div class="w-12 h-12 sm:w-16 sm:h-16 rounded-xl sm:rounded-2xl flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 transition-transform duration-300" style="background: linear-gradient(135deg, #20b2aa, #10b981);">
                <svg class="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 class="text-lg sm:text-xl font-bold mb-2 sm:mb-3" style="color: var(--text-primary);">찍고 나누기</h3>
              <p class="text-sm sm:text-base mb-4 sm:mb-6" style="color: var(--text-secondary);">
                영수증을 찍으면 자동으로 금액을 인식하고 친구들과 나눕니다.
              </p>

              <div class="rounded-xl sm:rounded-2xl p-3 sm:p-4" style="background: var(--surface-hover); border: 1px solid var(--border);">
                <div class="text-center mb-2 sm:mb-3">
                  <div class="text-[10px] sm:text-xs" style="color: var(--text-muted);">총 금액</div>
                  <div class="text-xl sm:text-2xl font-bold" style="color: var(--text-primary);">&#8361;48,500</div>
                </div>
                <div class="h-px my-2 sm:my-3" style="background: var(--border);"></div>
                <div class="space-y-1 sm:space-y-2 text-xs sm:text-sm">
                  <div class="flex justify-between">
                    <span style="color: var(--text-secondary);">내 금액</span>
                    <span class="font-medium" style="color: var(--accent);">&#8361;16,167</span>
                  </div>
                  <div class="flex justify-between items-center">
                    <span style="color: var(--text-secondary);">3명과 나누기</span>
                    <svg class="w-4 h-4" style="color: var(--text-muted);" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
                <button
                  onclick={() => showSettlementModal = true}
                  class="w-full mt-3 sm:mt-4 py-2 text-white rounded-lg sm:rounded-xl text-xs sm:text-sm font-medium hover:shadow-lg transition-shadow duration-200 cursor-pointer"
                  style="background: linear-gradient(135deg, #20b2aa, #10b981);"
                >
                  정산 요청 보내기
                </button>
              </div>
            </div>
          </div>

          <!-- Privacy First -->
          <div class="card card-hover border-2 rounded-2xl sm:rounded-3xl p-6 sm:p-8 group" style="border-color: var(--border);">
            <div class="w-12 h-12 sm:w-16 sm:h-16 rounded-xl sm:rounded-2xl flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 transition-transform duration-300" style="background: linear-gradient(135deg, #059669, #10b981);">
              <svg class="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <h3 class="text-lg sm:text-xl font-bold mb-2" style="color: var(--text-primary);">개인정보 우선</h3>
            <p class="text-sm sm:text-base" style="color: var(--text-secondary);">
              여행 데이터는 기기에만 저장됩니다. 종단간 암호화로 안전하게 공유하세요.
            </p>
          </div>

          <!-- Works Offline -->
          <div class="card card-hover border-2 rounded-2xl sm:rounded-3xl p-6 sm:p-8 group" style="border-color: var(--border);">
            <div class="w-12 h-12 sm:w-16 sm:h-16 rounded-xl sm:rounded-2xl flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 transition-transform duration-300" style="background: linear-gradient(135deg, #0d9488, #14b8a6);">
              <svg class="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 class="text-lg sm:text-xl font-bold mb-2" style="color: var(--text-primary);">오프라인 지원</h3>
            <p class="text-sm sm:text-base" style="color: var(--text-secondary);">
              인터넷 없이도 일정과 예산 추적기를 사용할 수 있습니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA Section with Newsletter -->
  <section class="py-16 sm:py-24" style="background: var(--bg-deeper);">
    <div class="max-w-7xl mx-auto px-6">
      <div class="rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-12" style="background: linear-gradient(135deg, #20b2aa, #10b981);">
        <div class="max-w-2xl mx-auto text-center">
          {#if subscribed}
            <div class="py-8">
              <div class="w-16 h-16 mx-auto bg-white/20 rounded-full flex items-center justify-center mb-4">
                <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 class="text-2xl sm:text-3xl font-bold text-white mb-3">구독 완료!</h2>
              <p class="text-white/80 text-sm sm:text-base">
                곧 유용한 여행 정보를 보내드릴게요. 감사합니다!
              </p>
            </div>
          {:else}
            <h2 class="text-2xl sm:text-3xl font-bold text-white mb-3 sm:mb-4">최신 소식 받기</h2>
            <p class="text-white/80 text-sm sm:text-base mb-4 sm:mb-6">
              여행 팁, 기능 업데이트, 특별 혜택을 이메일로 받아보세요.
            </p>
            <form onsubmit={(e) => { e.preventDefault(); handleSubscribe(); }} class="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <input
                type="email"
                bind:value={email}
                placeholder="이메일을 입력하세요"
                class="flex-1 px-4 sm:px-6 py-3 sm:py-4 rounded-xl backdrop-blur-sm focus:outline-none focus:ring-2 text-sm sm:text-base placeholder:text-slate-500"
                style="background: rgba(255,255,255,0.96); color: #0f172a; border: 1px solid rgba(255,255,255,0.28);"
                required
              />
              <button
                type="submit"
                disabled={subscribing}
                class="px-6 sm:px-8 py-3 sm:py-4 rounded-xl transition-colors duration-200 text-sm sm:text-base font-semibold disabled:opacity-50 cursor-pointer hover:bg-white"
                style="background: rgba(255,255,255,0.92); color: #0f172a;"
              >
                {subscribing ? "구독 중..." : "구독하기"}
              </button>
            </form>
          {/if}
        </div>
      </div>
    </div>
  </section>

  <!-- Footer -->
  <footer class="pt-12 sm:pt-16 pb-6 sm:pb-8" style="background: var(--bg-deeper); color: var(--text-primary);">
    <div class="max-w-7xl mx-auto px-6">
      <div class="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-8 sm:mb-12">
        <div>
          <h3 class="text-sm sm:text-base font-semibold mb-3 sm:mb-4" style="color: var(--text-primary);">제품</h3>
          <ul class="space-y-2 sm:space-y-3">
            <li><button onclick={() => showFeatureAlert("기능")} class="text-xs sm:text-sm transition-colors duration-200 cursor-pointer" style="color: var(--text-secondary);">기능</button></li>
            <li><button onclick={() => showFeatureAlert("가격")} class="text-xs sm:text-sm transition-colors duration-200 cursor-pointer" style="color: var(--text-secondary);">가격</button></li>
            <li><Link href="/signup" class="text-xs sm:text-sm transition-colors duration-200 cursor-pointer" style="color: var(--text-secondary);">다운로드</Link></li>
            <li><button onclick={() => showFeatureAlert("업데이트")} class="text-xs sm:text-sm transition-colors duration-200 cursor-pointer" style="color: var(--text-secondary);">업데이트</button></li>
          </ul>
        </div>

        <div>
          <h3 class="text-sm sm:text-base font-semibold mb-3 sm:mb-4" style="color: var(--text-primary);">회사</h3>
          <ul class="space-y-2 sm:space-y-3">
            <li><button onclick={() => showFeatureAlert("소개")} class="text-xs sm:text-sm transition-colors duration-200 cursor-pointer" style="color: var(--text-secondary);">소개</button></li>
            <li><button onclick={() => showFeatureAlert("블로그")} class="text-xs sm:text-sm transition-colors duration-200 cursor-pointer" style="color: var(--text-secondary);">블로그</button></li>
            <li><button onclick={() => showFeatureAlert("채용")} class="text-xs sm:text-sm transition-colors duration-200 cursor-pointer" style="color: var(--text-secondary);">채용</button></li>
            <li><button onclick={() => showFeatureAlert("미디어킷")} class="text-xs sm:text-sm transition-colors duration-200 cursor-pointer" style="color: var(--text-secondary);">미디어킷</button></li>
          </ul>
        </div>

        <div>
          <h3 class="text-sm sm:text-base font-semibold mb-3 sm:mb-4" style="color: var(--text-primary);">지원</h3>
          <ul class="space-y-2 sm:space-y-3">
            <li><button onclick={() => showFeatureAlert("도움말")} class="text-xs sm:text-sm transition-colors duration-200 cursor-pointer" style="color: var(--text-secondary);">도움말</button></li>
            <li><button onclick={() => showFeatureAlert("커뮤니티")} class="text-xs sm:text-sm transition-colors duration-200 cursor-pointer" style="color: var(--text-secondary);">커뮤니티</button></li>
            <li><button onclick={() => showFeatureAlert("가이드")} class="text-xs sm:text-sm transition-colors duration-200 cursor-pointer" style="color: var(--text-secondary);">가이드</button></li>
            <li><button onclick={() => showFeatureAlert("API 문서")} class="text-xs sm:text-sm transition-colors duration-200 cursor-pointer" style="color: var(--text-secondary);">API 문서</button></li>
          </ul>
        </div>

        <div>
          <h3 class="text-sm sm:text-base font-semibold mb-3 sm:mb-4" style="color: var(--text-primary);">법적고지</h3>
          <ul class="space-y-2 sm:space-y-3">
            <li><button onclick={() => showFeatureAlert("개인정보처리방침")} class="text-xs sm:text-sm transition-colors duration-200 cursor-pointer" style="color: var(--text-secondary);">개인정보처리방침</button></li>
            <li><button onclick={() => showFeatureAlert("이용약관")} class="text-xs sm:text-sm transition-colors duration-200 cursor-pointer" style="color: var(--text-secondary);">이용약관</button></li>
            <li><button onclick={() => showFeatureAlert("쿠키정책")} class="text-xs sm:text-sm transition-colors duration-200 cursor-pointer" style="color: var(--text-secondary);">쿠키정책</button></li>
            <li><button onclick={() => showFeatureAlert("라이선스")} class="text-xs sm:text-sm transition-colors duration-200 cursor-pointer" style="color: var(--text-secondary);">라이선스</button></li>
          </ul>
        </div>
      </div>

      <div class="pt-6 sm:pt-8 border-t" style="border-color: var(--border);">
        <div class="flex flex-col md:flex-row justify-between items-center gap-4">
          <div class="flex items-center gap-3">
            <img src="/icon.png" alt="TripHelper" class="w-8 h-8 sm:w-10 sm:h-10 rounded-lg sm:rounded-xl" />
            <div>
              <div class="text-sm sm:text-base font-medium" style="color: var(--text-primary);">TripHelper</div>
              <div class="text-[10px] sm:text-sm" style="color: var(--text-muted);">&copy; 2025 TripHelper Inc.</div>
            </div>
          </div>

          <div class="flex items-center gap-3 sm:gap-4">
            {#each [
              { label: "Twitter", icon: "M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" },
              { label: "Instagram", icon: "M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 01-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 017.8 2m7.7 3.5A1.5 1.5 0 0017 7a1.5 1.5 0 00-1.5-1.5M12 7a5 5 0 105 5 5 5 0 00-5-5m0 2a3 3 0 110 6 3 3 0 010-6z" },
              { label: "GitHub", icon: "M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22" }
            ] as social}
              <button aria-label={social.label} class="w-8 h-8 sm:w-10 sm:h-10 rounded-lg sm:rounded-xl flex items-center justify-center transition-colors duration-200 cursor-pointer" style="background: var(--surface); color: var(--text-secondary);">
                <svg class="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d={social.icon} />
                </svg>
              </button>
            {/each}
            <button aria-label="Email" class="w-8 h-8 sm:w-10 sm:h-10 rounded-lg sm:rounded-xl flex items-center justify-center transition-colors duration-200 cursor-pointer" style="background: var(--surface); color: var(--text-secondary);">
              <svg class="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </footer>
</div>

<!-- Video Modal -->
{#if showVideoModal}
  <!-- svelte-ignore a11y_click_events_have_key_events a11y_no_noninteractive_element_interactions -->
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/80"
    onclick={() => showVideoModal = false}
    role="dialog"
    aria-modal="true"
    tabindex="-1"
    aria-labelledby="video-modal-title"
  >
    <div class="relative w-full max-w-4xl mx-4" role="document">
      <button
        aria-label="영상 닫기"
        onclick={() => showVideoModal = false}
        class="absolute -top-12 right-0 text-white hover:text-muted transition-colors duration-200 cursor-pointer"
      >
        <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <div class="relative pb-[56.25%] h-0 bg-black rounded-2xl overflow-hidden">
        <iframe
          class="absolute top-0 left-0 w-full h-full"
          src={videoUrl}
          title="TripHelper 소개 영상"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
{/if}

<!-- Soulmate Schedule Modal -->
{#if showSoulmateModal}
  <!-- svelte-ignore a11y_click_events_have_key_events a11y_no_noninteractive_element_interactions -->
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
    onclick={() => showSoulmateModal = false}
    role="dialog"
    aria-modal="true"
    tabindex="-1"
    aria-labelledby="soulmate-modal-title"
  >
    <!-- svelte-ignore a11y_click_events_have_key_events a11y_no_static_element_interactions a11y_no_noninteractive_element_interactions -->
    <div
      class="rounded-2xl max-w-md w-full mx-4 overflow-hidden shadow-2xl"
      style="background: var(--surface);"
      role="document"
      onclick={(e) => e.stopPropagation()}
    >
      <div class="p-6 text-white" style="background: linear-gradient(135deg, #0d9488, #14b8a6);">
        <div class="flex items-center gap-4">
          <div class="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
            <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          <div>
            <h3 id="soulmate-modal-title" class="text-xl font-bold">맛집 탐험가의 일정</h3>
            <p class="text-white/70 text-sm">후쿠오카 3일 여행</p>
          </div>
        </div>
      </div>
      <div class="p-6 space-y-4 max-h-80 overflow-y-auto">
        {#each soulmateSchedule as day}
          <div class="border-l-4 pl-4" style="border-color: var(--accent);">
            <h4 class="font-semibold" style="color: var(--text-primary);">{day.day}</h4>
            <ul class="mt-2 space-y-1">
              {#each day.places as place}
                <li class="text-sm flex items-center gap-2" style="color: var(--text-secondary);">
                  <svg class="w-4 h-4 flex-shrink-0" style="color: var(--accent);" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  {place}
                </li>
              {/each}
            </ul>
          </div>
        {/each}
      </div>
      <div class="p-6 border-t" style="background: var(--surface-hover); border-color: var(--border);">
        <div class="flex gap-3">
          <button
            onclick={() => showSoulmateModal = false}
            class="btn btn-secondary flex-1 py-3 rounded-xl cursor-pointer"
          >
            닫기
          </button>
          <Link
            href="/signup"
            class="flex-1 py-3 text-white rounded-xl font-medium hover:shadow-lg transition-all duration-200 text-center cursor-pointer"
            style="background: linear-gradient(135deg, #20b2aa, #10b981);"
          >
            내 일정으로 복사
          </Link>
        </div>
      </div>
    </div>
  </div>
{/if}

<!-- Settlement Demo Modal -->
{#if showSettlementModal}
  <!-- svelte-ignore a11y_click_events_have_key_events a11y_no_noninteractive_element_interactions -->
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
    onclick={() => showSettlementModal = false}
    role="dialog"
    aria-modal="true"
    tabindex="-1"
    aria-labelledby="settlement-modal-title"
  >
    <!-- svelte-ignore a11y_click_events_have_key_events a11y_no_static_element_interactions a11y_no_noninteractive_element_interactions -->
    <div
      class="rounded-2xl max-w-md w-full mx-4 overflow-hidden shadow-2xl"
      style="background: var(--surface);"
      role="document"
      onclick={(e) => e.stopPropagation()}
    >
      <div class="p-6 text-white" style="background: linear-gradient(135deg, #20b2aa, #10b981);">
        <div class="flex items-center gap-3">
          <div class="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
            <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <h3 id="settlement-modal-title" class="text-xl font-bold">정산 요청 완료!</h3>
            <p class="text-white/70 text-sm">카카오톡으로 전송됨</p>
          </div>
        </div>
      </div>
      <div class="p-6 space-y-4">
        <div class="rounded-xl p-4" style="background: var(--surface-hover);">
          <div class="text-center mb-4">
            <p class="text-sm" style="color: var(--text-muted);">총 금액</p>
            <p class="text-3xl font-bold" style="color: var(--text-primary);">&#8361;48,500</p>
          </div>
          <div class="h-px my-4" style="background: var(--border);"></div>
          <div class="space-y-3">
            {#each [
              { name: "나", initial: "나", color: "#20b2aa", bg: "rgba(32,178,170,0.1)" },
              { name: "친구1", initial: "친1", color: "#10b981", bg: "rgba(16,185,129,0.1)" },
              { name: "친구2", initial: "친2", color: "#0d9488", bg: "rgba(13,148,136,0.1)" }
            ] as person, i}
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-2">
                  <div class="w-8 h-8 rounded-full flex items-center justify-center font-medium text-sm" style="background: {person.bg}; color: {person.color};">{person.initial}</div>
                  <span style="color: var(--text-primary);">{person.name}</span>
                </div>
                <span class="font-medium" style="color: var(--text-primary);">&#8361;{i < 2 ? "16,167" : "16,166"}</span>
              </div>
            {/each}
          </div>
        </div>
        <div class="flex items-center gap-2 p-3 rounded-xl" style="background: rgba(16,185,129,0.08);">
          <svg class="w-5 h-5 flex-shrink-0" style="color: #10b981;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
          <span class="text-sm" style="color: #059669;">정산 요청 메시지가 전송되었습니다</span>
        </div>
      </div>
      <div class="p-6 border-t" style="background: var(--surface-hover); border-color: var(--border);">
        <div class="flex gap-3">
          <button
            onclick={() => showSettlementModal = false}
            class="btn btn-secondary flex-1 py-3 rounded-xl cursor-pointer"
          >
            닫기
          </button>
          <Link
            href="/signup"
            class="flex-1 py-3 text-white rounded-xl font-medium hover:shadow-lg transition-all duration-200 text-center cursor-pointer"
            style="background: linear-gradient(135deg, #20b2aa, #10b981);"
          >
            직접 사용해보기
          </Link>
        </div>
      </div>
    </div>
  </div>
{/if}
